"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkupResolver = exports.MarkupParser = exports.Parser = void 0;
const equivalent_1 = require("./equivalent");
const information_1 = require("./information");
const information_2 = require("./information");
const parsed_word_1 = require("./parsed-word");
const part_1 = require("./part");
const pronouncer_1 = require("./pronouncer");
const relation_1 = require("./relation");
const section_1 = require("./section");
class Parser {
    constructor(resolver, configs) {
        this.markupParser = new MarkupParser(resolver);
        this.configs = configs;
    }
    static createSimple() {
        const resolver = MarkupResolver.createSimple();
        const parser = new Parser(resolver);
        return parser;
    }
    static createKeep() {
        const resolver = MarkupResolver.createKeep();
        const parser = new Parser(resolver);
        return parser;
    }
    parse(word) {
        var _a, _b, _c, _d;
        const pronouncer = pronouncer_1.PronouncerCreator.createByVersion((_b = (_a = word.dictionary) === null || _a === void 0 ? void 0 : _a.settings.version) !== null && _b !== void 0 ? _b : "", (_c = this.configs) === null || _c === void 0 ? void 0 : _c.pronouncerConfigs);
        const name = word.name;
        const uniqueName = word.uniqueName;
        const date = word.date;
        const pronunciation = (_d = pronouncer === null || pronouncer === void 0 ? void 0 : pronouncer.convert(name)) !== null && _d !== void 0 ? _d : null;
        const parts = {};
        for (const [language, content] of Object.entries(word.contents)) {
            if (content !== undefined) {
                const part = this.parsePart(content);
                parts[language] = part;
            }
        }
        const parsedWord = new parsed_word_1.ParsedWord(name, uniqueName, date, pronunciation, parts);
        return parsedWord;
    }
    parsePart(content) {
        const lines = content.split(/\r\n|\r|\n/);
        const sections = [];
        let before = true;
        let currentSort = null;
        let currentEquivalents = [];
        let currentInformations = [];
        let currentRelations = [];
        for (const line of lines) {
            const sortMatch = line.match(/^\+\s*(?:<(.*?)>)/);
            if (sortMatch) {
                if (!before) {
                    const section = new section_1.Section(currentSort, currentEquivalents, currentInformations, currentRelations);
                    sections.push(section);
                }
                before = false;
                currentSort = sortMatch[1] || null;
                currentEquivalents = [];
                currentInformations = [];
                currentRelations = [];
            }
            const field = this.parseField(line);
            if (field !== null) {
                if (field instanceof equivalent_1.Equivalent) {
                    currentEquivalents.push(field);
                }
                else if (field instanceof information_1.Information) {
                    currentInformations.push(field);
                }
                else if (field instanceof relation_1.Relation) {
                    currentRelations.push(field);
                }
            }
        }
        if (!before) {
            const section = new section_1.Section(currentSort, currentEquivalents, currentInformations, currentRelations);
            sections.push(section);
        }
        const part = new part_1.Part(sections);
        return part;
    }
    parseField(line) {
        if (line.match(/^=\??/)) {
            return this.parseEquivalent(line);
        }
        else if (line.match(/^\w\??:/)) {
            return this.parseInformation(line);
        }
        else if (line.match(/^\-/)) {
            return this.parseRelation(line);
        }
        else {
            return null;
        }
    }
    parseEquivalent(line) {
        const match = line.match(/^=(\?)?\s*(?:<(.*?)>\s*)?(?:\((.*?)\)\s*)?(.*)$/);
        if (match) {
            const hidden = match[1] !== undefined;
            const category = (match[2] !== undefined && match[2] !== "") ? match[2] : null;
            const frame = (match[3] !== undefined && match[3] !== "") ? this.markupParser.parse(match[3]) : null;
            const names = match[4].split(/\s*,\s*/).map((rawName) => this.markupParser.parse(rawName));
            const equivalent = new equivalent_1.Equivalent(category, frame, names, hidden);
            return equivalent;
        }
        else {
            return null;
        }
    }
    parseInformation(line) {
        const match = line.match(/^(\w)(\?)?:\s*(?:@(\d+)\s*)?(.*)$/);
        if (match) {
            const kind = information_2.InformationKindUtil.fromTag(match[1]);
            const hidden = match[2] !== undefined;
            const date = (match[3] !== undefined) ? parseInt(match[3], 10) : null;
            const rawText = match[4];
            if (kind === "phrase") {
                const textMatch = rawText.match(/^(.*?)\s*→\s*(.*?)(?:\s*\|\s*(.*))?$/);
                if (textMatch) {
                    const expression = this.markupParser.parse(textMatch[1]);
                    const equivalents = textMatch[2].split(/\s*,\s*/).map((rawName) => this.markupParser.parse(rawName));
                    const text = (textMatch[3] !== undefined && textMatch[3] !== "") ? this.markupParser.parse(textMatch[3]) : null;
                    const information = new information_1.PhraseInformation(expression, equivalents, text, date, hidden);
                    return information;
                }
                else {
                    return null;
                }
            }
            else if (kind === "example") {
                const textMatch = rawText.match(/^(.*?)\s*→\s*(.*?)$/);
                if (textMatch) {
                    const sentence = this.markupParser.parse(textMatch[1]);
                    const translation = this.markupParser.parse(textMatch[2]);
                    const information = new information_1.ExampleInformation(sentence, translation, date, hidden);
                    return information;
                }
                else {
                    return null;
                }
            }
            else if (kind !== undefined) {
                const text = this.markupParser.parse(rawText);
                const information = new information_1.NormalInformation(kind, text, date, hidden);
                return information;
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }
    parseRelation(line) {
        const match = line.match(/^\-\s*(?:<(.*?)>\s*)?(.*)$/);
        if (match) {
            const title = (match[1] !== undefined && match[1] !== "") ? match[1] : null;
            const entries = match[2].split(/\s*,\s*/).map((rawName) => {
                if (rawName.endsWith("*")) {
                    const name = this.markupParser.parse(rawName.substring(0, rawName.length - 1));
                    return { name, refer: true };
                }
                else {
                    const name = this.markupParser.parse(rawName);
                    return { name, refer: false };
                }
            });
            const relation = new relation_1.Relation(title, entries);
            return relation;
        }
        else {
            return null;
        }
    }
    lookupSort(word, language) {
        const content = word.contents[language];
        if (content !== undefined) {
            const match = content.match(/^\+\s*(?:<(.*?)>)/m);
            if (match) {
                return match[1];
            }
            else {
                return null;
            }
        }
        else {
            return undefined;
        }
    }
    lookupEquivalentNames(word, language, onlyVisible) {
        const content = word.contents[language];
        if (content !== undefined) {
            const names = [];
            const regexp = /^=(\?)?\s*(?:<(.*?)>\s*)?(?:\((.*?)\)\s*)?(.*)$/mg;
            let match;
            while (match = regexp.exec(content)) {
                if (!onlyVisible || !match[1]) {
                    names.push(...match[4].split(/\s*,\s*/).map((rawName) => this.markupParser.parse(rawName)));
                }
            }
            return names;
        }
        else {
            return undefined;
        }
    }
    lookupPhraseEquivalentNames(word, language, onlyVisible) {
        const content = word.contents[language];
        if (content !== undefined) {
            const names = [];
            const regexp = /^(P)(\?)?:\s*(?:@(\d+)\s*)?(.*?)\s*→\s*(.*?)(?:\s*\|\s*(.*))?$/mg;
            let match;
            while (match = regexp.exec(content)) {
                if (!onlyVisible || !match[1]) {
                    names.push(...match[5].split(/\s*,\s*/).map((rawName) => this.markupParser.parse(rawName)));
                }
            }
            return names;
        }
        else {
            return undefined;
        }
    }
}
exports.Parser = Parser;
class MarkupParser {
    constructor(resolver) {
        this.source = "";
        this.pointer = 0;
        this.resolver = resolver;
    }
    parse(source) {
        this.source = source;
        this.pointer = 0;
        const node = this.consume();
        return node;
    }
    consume() {
        const children = [];
        while (true) {
            const char = this.source.charAt(this.pointer);
            const remaining = this.source.substring(this.pointer);
            if (char === "{") {
                const element = this.consumeBrace();
                children.push(element);
            }
            else if (char === "[") {
                const element = this.consumeBracket();
                children.push(element);
            }
            else if (char === "/") {
                const [, element] = this.consumeSlash();
                children.push(element);
            }
            else if (remaining.match(/^H(\d+)/)) {
                const element = this.consumeHairia();
                children.push(element);
            }
            else if (char === "") {
                break;
            }
            else {
                const string = this.consumeString();
                children.push(string);
            }
        }
        const node = this.resolver.join(children);
        return node;
    }
    consumeBrace() {
        this.pointer++;
        const children = this.consumeBraceChildren();
        const element = this.resolver.resolveBrace(children);
        this.pointer++;
        return element;
    }
    consumeBracket() {
        this.pointer++;
        const children = this.consumeBracketChildren();
        const element = this.resolver.resolveBracket(children);
        this.pointer++;
        return element;
    }
    consumeSlash() {
        this.pointer++;
        const string = this.consumeSlashString();
        const element = this.resolver.resolveSlash(string);
        this.pointer++;
        return [string, element];
    }
    consumeHairia() {
        this.pointer++;
        let hairiaString = "";
        while (true) {
            const char = this.source.charAt(this.pointer);
            if (char.match(/^\d$/)) {
                this.pointer++;
                hairiaString += char;
            }
            else {
                break;
            }
        }
        const hairia = parseInt(hairiaString, 10);
        const element = this.resolver.resolveHairia(hairia);
        return element;
    }
    consumeBraceChildren() {
        const children = [];
        let currentChildren = [];
        let currentName = "";
        while (true) {
            const char = this.source.charAt(this.pointer);
            if (char === " " || char === "," || char === "." || char === "!" || char === "?") {
                if (currentChildren.length > 0) {
                    children.push(this.resolver.resolveLink(currentName, currentChildren));
                    currentChildren = [];
                    currentName = "";
                }
                this.pointer++;
                children.push(char);
            }
            else if (char === "}" || char === "") {
                if (currentChildren.length > 0) {
                    children.push(this.resolver.resolveLink(currentName, currentChildren));
                    currentChildren = [];
                    currentName = "";
                }
                break;
            }
            else if (char === "/") {
                const [slashName, slashElement] = this.consumeSlash();
                currentChildren.push(slashElement);
                currentName += slashName;
            }
            else {
                const string = this.consumeBraceString();
                currentChildren.push(string);
                currentName += string;
            }
        }
        return children;
    }
    consumeBracketChildren() {
        const children = [];
        while (true) {
            const char = this.source.charAt(this.pointer);
            if (char === "/") {
                const [, slashElement] = this.consumeSlash();
                children.push(slashElement);
            }
            else if (char === "]" || char === "") {
                break;
            }
            else {
                const string = this.consumeBracketString();
                children.push(string);
            }
        }
        return children;
    }
    consumeString() {
        let string = "";
        while (true) {
            const char = this.source.charAt(this.pointer);
            const remaining = this.source.substring(this.pointer);
            if (char === "{" || char === "[" || char === "/" || char === "") {
                break;
            }
            else if (remaining.match(/^H(\d+)/)) {
                break;
            }
            else if (char === "`") {
                string += this.consumeEscape();
            }
            else {
                this.pointer++;
                string += char;
            }
        }
        if (this.resolver.modifyPunctuations) {
            string = string.replace(/、/g, "、 ");
            string = string.replace(/。/g, "。 ");
            string = string.replace(/「/g, " 「");
            string = string.replace(/」/g, "」 ");
            string = string.replace(/『/g, " 『");
            string = string.replace(/』/g, "』 ");
            string = string.replace(/〈/g, " 〈");
            string = string.replace(/〉/g, "〉 ");
            string = string.replace(/(、|。)\s+(」|』)/g, "$1$2");
            string = string.replace(/(」|』|〉)\s+(、|。|,|\.)/g, "$1$2");
            string = string.replace(/(\(|「|『)\s+(「|『)/g, "$1$2");
        }
        return string;
    }
    consumeBraceString() {
        let string = "";
        while (true) {
            const char = this.source.charAt(this.pointer);
            if (char === "}" || char === "/" || char === "" || char === " " || char === "," || char === "." || char === "!" || char === "?") {
                break;
            }
            else if (char === "`") {
                string += this.consumeEscape();
            }
            else {
                this.pointer++;
                string += char;
            }
        }
        return string;
    }
    consumeBracketString() {
        let string = "";
        while (true) {
            const char = this.source.charAt(this.pointer);
            if (char === "]" || char === "/" || char === "") {
                break;
            }
            else if (char === "`") {
                string += this.consumeEscape();
            }
            else {
                this.pointer++;
                string += char;
            }
        }
        return string;
    }
    consumeSlashString() {
        let string = "";
        while (true) {
            const char = this.source.charAt(this.pointer);
            if (char === "/" || char === "") {
                break;
            }
            else if (char === "`") {
                string += this.consumeEscape();
            }
            else {
                this.pointer++;
                string += char;
            }
        }
        return string;
    }
    consumeEscape() {
        this.pointer++;
        const char = this.source.charAt(this.pointer);
        if (char !== "") {
            const string = this.resolver.resolveEscape(char);
            this.pointer++;
            return string;
        }
        else {
            return "";
        }
    }
}
exports.MarkupParser = MarkupParser;
class MarkupResolver {
    constructor(spec) {
        var _a, _b, _c, _d;
        this.resolveLink = spec.resolveLink;
        this.resolveBracket = spec.resolveBracket;
        this.resolveBrace = (_a = spec.resolveBrace) !== null && _a !== void 0 ? _a : spec.resolveBracket;
        this.resolveSlash = spec.resolveSlash;
        this.resolveHairia = (_b = spec.resolveHairia) !== null && _b !== void 0 ? _b : MarkupResolver.createNoopHairiaResolver();
        this.resolveEscape = (_c = spec.resolveEscape) !== null && _c !== void 0 ? _c : MarkupResolver.createNoopEscapeResolver();
        this.join = spec.join;
        this.modifyPunctuations = (_d = spec.modifyPunctuations) !== null && _d !== void 0 ? _d : false;
    }
    static createNoopEscapeResolver() {
        const resolve = function (char) {
            return char;
        };
        return resolve;
    }
    static createNoopHairiaResolver() {
        const resolve = function (hairia) {
            return "H" + hairia.toString();
        };
        return resolve;
    }
    static createSimple() {
        const resolveLink = function (name, children) {
            return children.join("");
        };
        const resolveBracket = function (children) {
            return children.join("");
        };
        const resolveSlash = function (string) {
            return string;
        };
        const join = function (nodes) {
            return nodes.join("");
        };
        const resolver = new MarkupResolver({ resolveLink, resolveBracket, resolveSlash, join });
        return resolver;
    }
    static createKeep() {
        const resolveLink = function (name, children) {
            return children.join("");
        };
        const resolveBracket = function (children) {
            return "[" + children.join("") + "]";
        };
        const resolveBrace = function (children) {
            return "{" + children.join("") + "}";
        };
        const resolveSlash = function (string) {
            return "/" + string + "/";
        };
        const resolveEscape = function (char) {
            return "`" + char;
        };
        const join = function (nodes) {
            return nodes.join("");
        };
        const resolver = new MarkupResolver({ resolveLink, resolveBracket, resolveBrace, resolveSlash, resolveEscape, join });
        return resolver;
    }
}
exports.MarkupResolver = MarkupResolver;
